import React from 'react';
import { useAppState } from '../hooks/useAppState';
import CelebrationEffect from '../components/CelebrationEffect';
import QRCodeImage from '../components/QRCodeImage';
import { getConfig } from '../services/configManager';
import { formatDate } from '../utils/validation';
import CouponCard from '../components/CouponCard';
import CalculatorCard from '../components/CalculatorCard';

const GuestThankYouPage: React.FC = () => {
  const { state, resetState } = useAppState();
  const { currentTicket, orderResponse } = state;

  const handleBackToHome = () => {
    resetState();
  };


  return (
    <div className="flex-1 flex items-center justify-center p-5">
      <div className="container-card w-full max-w-sm">
        <h1 className="text-title font-extrabold text-black text-center mb-8">
          Thank You!
        </h1>

        <div className="text-center text-black text-md mb-8">
          <div>
            <p className="mb-4">
             You are good to go!
            </p>
          </div>
        </div>
        
        {/* Ticket Summary */}
        {currentTicket && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-black text-lg mb-3 text-center">Ticket Summary</h2>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Ticket:</span>
                <span className="text-black font-medium">{currentTicket.ticketNumber || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Parking Lot:</span>
                <span className="text-black font-medium">{currentTicket.spot?.name || currentTicket.spot?.code || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Car Plate:</span>
                <span className="text-black font-medium">{currentTicket.vehicleNumber || 'N/A'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Entry:</span>
                <span className="text-black font-medium">{formatDate(currentTicket.entryDate)}</span>
              </div>
            </div>
          </div>
        )}

        {/* QR Code */}
        {orderResponse && (orderResponse.order.options?.showQR === true) && (
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-black text-lg mb-3 text-center">Your Credential</h2>
            <div className="flex flex-col items-center space-y-2">
              <p className="text-gray-700 text-sm text-center">
                This QR code is your credential. Scan it at the entry or exit terminal to get in or out.
              </p>
              <QRCodeImage
                qrCodeUrl={getConfig().API.QR_CODE_URL.replace('{order-id}', orderResponse.order.id)}
                alt="Order QR Code"
                className="w-48 h-48 border border-gray-300 rounded"
                maxRetries={5}
                retryDelay={3000}
              />
              <p className="text-gray-500 text-xs text-center">
                Present at the terminal scanner when needed.
              </p>
            </div>
          </div>
        )}

        <div className="text-center text-black text-md mb-8">
          <div>
            <p className="mb-4">
            Your credit card will be charged at exit when you leave, A receipt will be sent to your email shortly after
            </p>            
            <p>
              Thank you for using our parking service. Have a great day!
            </p>
          </div>
        </div>

        <CouponCard />
        <CalculatorCard />
        
        {/* <div className="flex flex-col gap-4">
          <button
            onClick={handleBackToHome}
            className="btn-primary w-full"
          >
            Back to Home
          </button>
        </div> */}
      </div>
      
      {/* Celebration Effect */}
      <CelebrationEffect duration={5000} starCount={20} />
    </div>
  );
};

export default GuestThankYouPage; 